import { utils } from "ethers";
export var isEthereumAddress = function (address) {
    try {
        if (utils.getAddress(address))
            return true;
        return false;
    }
    catch (e) {
        if (e.reason == "invalid address") {
            return false;
        }
        else
            throw e;
    }
};
//# sourceMappingURL=utils.js.map